import { z } from "zod";
import { UserSchema } from "./User";

export const FileSchema = z.object({
  id: z.number(),
  type: z.string(),
  subtype: z.string().nullable(),
  extension: z.string().nullable(),
  dbName: z.string(),
  fileName: z.string(),
  mimeType: z.string(),
  fileSize: z.number(),
  dateCreate: z.string(),
  md5: z.string().nullable(),
  fileToken: z.string(),
  isTmp: z.boolean(),
  isAttachment: z.boolean(),
  uris: z.object({
    show: z.string(),
    get: z.string(),
  }),
  user: UserSchema.nullable(),
});

export type File = z.infer<typeof FileSchema>;
